module.exports = __webpack_public_path__ + "static/icon_color_shopping-61e17bc1fe2c4e3df057f7ee41292d19.png";